export enum VariantStandard {
  Standard = "Standard",
  NonStandard = "Non-Standard"
}
